export enum THGChargingPlugType {
    TYPE1 = 'type1',
    TYPE2 = 'type2',
    CCS = 'ccs',
    CHAdeMO = 'chademo',
    TESLA_SUPERCHARGER = 'tesla-supercharger',
    SCHUKO = 'schuko',
    CEE = 'cee',
}
